<template>
  <v-row v-resize="onResize" no-gutters align="start" justify="center">
    <v-col cols="12">
      <div class="d-flex justify-end pa-1">
        Total Saldo Pendiente: &nbsp;
        <span
          :class="[
            'font-weight-bold body-2',
            {
              'error--text': sumaPendiente < 0,
            },
          ]"
        >
          {{ simboloMoneda[tipoMoneda] }}
          {{ sumaPendiente | numeral("0,0.00") }}
        </span>
      </div>
      <v-data-table
        :loading="datosNew.length === 0 ? '#002f6c' : null"
        :headers="headersCliente"
        :items="datosNew"
        :hide-default-header="isMobile"
        :class="{ mobile: isMobile }"
        height="600px"
        fixed-header
        :search="search"
        :custom-filter="filteRif"
        hide-default-footer
        disable-pagination
        single-select
        sort-by="position"
        sort-desc
        item-key="NumeroDoc"
        class="elevation-1"
        :group-by="chkGrpClie_Rif ? 'Empresa' : 'NombreRif'"
        show-group-by
        dense
        :mobile-breakpoint="0"
        id="tbl_datos"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <PdfCliente
              :page="`clientedoc.php`"
              :xdata="infoTt(`ttDetDocPed`)"
              :xclisaldo="infoTt(`ttSaldos`)"
              :xcli="infoTt(`ttCliente`)"
              :namefile="`EstadoCuentaPendiente(` + nbFile + `)`"
              :titulo="`DETALLE ESTADO DE CUENTA PENDIENTE`"
            />

            <ExportDocsPendientes
              v-if="dataUser.TipoUsuario == 'U'"
              :rows="datosNew"
              :orderkey="chkGrpClie_Rif"
              :tipodoc="
                DetalleCliente.dsDocument &&
                DetalleCliente.dsDocument.ttTotalTipoDoc
              "
              :cliente="
                DetalleCliente.dsDocument &&
                DetalleCliente.dsDocument.ttCliente &&
                DetalleCliente.dsDocument.ttCliente[0]
              "
            />
            <v-switch
              class="mx-5"
              hide-details
              v-if="Cliente.data.GrupoCliente!== 0"
              v-model="chkGrpClie_Rif"
              color="accent"
              inset
              flat
              dense
              :label="chkGrpClie_Rif ? `Grupo Empresa` : 'Grupo Rif'"
            ></v-switch>

            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="12" md="4" v-if="Cliente.data.GrupoCliente!== 0">
                <v-select
                  v-model="selectRif"
                  :items="rifList"
                  item-text="NombreRif"
                  item-value="Rif"
                  clearable
                  @click:clear="toggle"
                  clear-icon="mdi-close"
                  dense
                  outlined
                  chips
                  :menu-props="{
                    top: false,
                    offsetY: true,
                    maxHeight: '200',
                    maxWidth: '380',
                    closeOnContentClick: true,
                  }"
                  label="Por RIF "
                >
                  <template slot="selection" slot-scope="{ item }">
                    <v-chip color="accent mt-1 ml-n1 font-weight-bold" label>
                      {{ item.NombreRif }}
                    </v-chip>
                  </template>
                </v-select>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="search"
                  dense
                  outlined
                  color="primary"
                  single-line
                  append-icon="mdi-magnify"
                  label="Buscar por Num Doc o Monto/Saldo"
                  hide-details
                  type="text"
                  background-color="#EEEEEE"
                />
              </v-col>
            </v-row>
          </v-toolbar>
        </template>
        <!-- group-->
        <template
          v-slot:[`group.header`]="{ items, group, headers, toggle, isOpen }"
        >
          <td :colspan="headers.length">
            <v-btn @click="toggle" x-small icon :ref="group">
              <v-icon v-if="isOpen">mdi-minus</v-icon>
              <v-icon v-else>mdi-plus</v-icon>
            </v-btn>
            <span style="color: #002f6c" class="mx-6 font-weight-bold">
              {{
                chkGrpClie_Rif
                  ? items
                      .filter((x) => x.Empresa === group)
                      .map((x) => x.NombreCli)[0]
                  : items
                      .filter((x) => x.NombreRif === group)
                      .map((x) => x.NombreRif)[0]
              }}
            </span>
          </td>
        </template>
        <!-- summary -->
        <template v-slot:[`group.summary`]="{ items, group }" v-if="!isMobile">
          <td colspan="7"></td>
          <td
            :class="[
              'text-right font-weight-bold body-2',
              {
                'error--text':
                  montoGroupSumary({
                    isEmpreRif: chkGrpClie_Rif,
                    items,
                    keyMap: `MontoOriginal`,
                    group,
                    tipoMoneda,
                  }) < 0,
              },
            ]"
            style="width: 150px"
          >
            <span>{{ simboloMoneda[tipoMoneda] }}</span>
            {{
              montoGroupSumary({
                isEmpreRif: chkGrpClie_Rif,
                items,
                keyMap: `MontoOriginal`,
                group,
                tipoMoneda,
              }) | numeral("0,0.00")
            }}
          </td>
          <td
            :class="[
              'text-right font-weight-bold body-2',
              {
                'error--text':
                  montoGroupSumary({
                    isEmpreRif: chkGrpClie_Rif,
                    items,
                    keyMap: `MontoRetIva`,
                    group,
                    tipoMoneda,
                  }) < 0,
              },
            ]"
            style="width: 150px"
          >
            <span>{{ simboloMoneda[tipoMoneda] }}</span>
            {{
              montoGroupSumary({
                isEmpreRif: chkGrpClie_Rif,
                items,
                keyMap: `MontoRetIva`,
                group,
                tipoMoneda,
              }) | numeral("0,0.00")
            }}
          </td>

          <td
            :class="[
              'text-right font-weight-bold body-2',
              {
                'error--text':
                  montoGroupSumary({
                    isEmpreRif: chkGrpClie_Rif,
                    items,
                    keyMap: `MontoPagar`,
                    group,
                    tipoMoneda,
                  }) < 0,
              },
            ]"
            style="width: 150px"
          >
            <span>{{ simboloMoneda[tipoMoneda] }}</span>
            {{
              montoGroupSumary({
                isEmpreRif: chkGrpClie_Rif,
                items,
                keyMap: `MontoPagar`,
                group,
                tipoMoneda,
              }) | numeral("0,0.00")
            }}
          </td>
          <td
            :class="[
              'text-right font-weight-bold body-2',
              {
                'error--text':
                  montoGroupSumary({
                    isEmpreRif: chkGrpClie_Rif,
                    items,
                    keyMap: `SaldoPendiente`,
                    group,
                    tipoMoneda,
                  }) < 0,
              },
            ]"
            style="width: 150px"
          >
            <span>{{ simboloMoneda[tipoMoneda] }}</span>
            {{
              montoGroupSumary({
                isEmpreRif: chkGrpClie_Rif,
                items,
                keyMap: `SaldoPendiente`,
                group,
                tipoMoneda,
              }) | numeral("0,0.00")
            }}
          </td>
          <td></td>
        </template>
        <!-- data -->
        <template v-slot:item="{ item }">
          <tr
            :data-category-id="item.Empresa"
            :data-id="item.NumeroDoc"
            v-if="!isMobile"
          >
            <td class="d-print-none">
              <linkfact
                :itemfac="item.IndFactura"
                :numerodoc="item.NumeroDoc"
                :tipodoc="item.TD"
                :idtab="1"
                :transi="true"
              ></linkfact>
            </td>
            <td :class="['text-center']">
              {{ item.Rif }}
            </td>
            <td :class="['text-center']">
              {{ item.NumeroDoc }}
            </td>
            <td :class="['text-center']">
              {{ item.TipoDoc }}
            </td>
            <td :class="['text-center']">
              {{
                item.FechaEmision
                  ? moment(item.FechaEmision).format("DD/MM/YY")
                  : ""
              }}
            </td>
            <td :class="['text-center']">
              <v-edit-dialog
                v-if="item.FechaEntregaCli"
                transition="scroll-y-transition"
              >
                <span class="text-decoration-underline">
                  {{
                    item.FechaEntregaCli
                      ? moment(item.FechaEntregaCli).format("DD/MM/YY")
                      : ""
                  }}
                </span>

                <template v-slot:input v-if="DetalleCliente.dsDocument">
                  <v-card flat width="550" elevation="1">
                    <v-toolbar dense color="primary" dark style="height: 25px">
                      <v-toolbar-title class="body-1 mb-4">
                        Detalle de Despacho Documento N°
                        <strong>{{ item.NumeroDoc }}</strong></v-toolbar-title
                      >
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <TrackCliente
                      :detallecliente="DetalleCliente"
                      :numdoc="item.NumeroDoc"
                    />

                  </v-card>
                </template>
              </v-edit-dialog>
            </td>

            <td :class="['text-center']">
              {{
                item.FechaVence
                  ? moment(item.FechaVence).format("DD/MM/YY")
                  : ""
              }}
            </td>
            <td
              :class="[
                'text-right',
                {
                  'error--text': item.MontoOriginal[tipoMoneda] < 0,
                },
              ]"
              style="width: 150px"
            >
              {{ simboloMoneda[tipoMoneda] }}
              {{ item.MontoOriginal[tipoMoneda] | numeral("0,0.00") }}
            </td>
            <td
              :class="[
                'text-right',
               
              ]"
              style="width: 150px"
            >
              {{ simboloMoneda[tipoMoneda] }}
              {{ item.MontoRetIva[tipoMoneda] | numeral("0,0.00") }}
            </td>
            <td
              :class="[
                'text-right',
               
              ]"
              style="width: 150px"
            >
              {{ simboloMoneda[tipoMoneda] }}
              {{ item.MontoPagar[tipoMoneda] | numeral("0,0.00") }}
            </td>
            <td
              style="width: 150px"
              :class="[
                'text-right',
                {
                  'error--text': item.SaldoPendiente[tipoMoneda] < 0,
                },
              ]"
            >
              {{ simboloMoneda[tipoMoneda] }}
              {{ item.SaldoPendiente[tipoMoneda] | numeral("0,0.00") }}
            </td>
            <td :class="['text-center']">
              {{ item.DiasMora }}
            </td>
          </tr>
        </template>
        <template
          slot="body.append"
          v-if="datosNew.length !== 0 && selectRif === 0"
        >
          <tr>
            <th v-for="n in 7" :key="n"></th>
            <th
              :class="[
                'subtitle-1',
                'text-right',
                'font-weight-bold',
                'text-no-wrap',
                {
                  'error--text': montoTotalSumary({
                    keyMap: `MontoOriginal`,
                    items: datosNew,
                    tipoMoneda: tipoMoneda,
                  }).includes('-'),
                },
              ]"
            >
              {{
                `${simboloMoneda[tipoMoneda]} ${montoTotalSumary({
                  keyMap: `MontoOriginal`,
                  items: datosNew,
                  tipoMoneda: tipoMoneda,
                })}`
              }}
            </th>
            <th
              :class="[
                'subtitle-1',
                'text-right',
                'font-weight-bold',
                'text-no-wrap',
                {
                  'error--text': montoTotalSumary({
                    keyMap: `MontoRetIva`,
                    items: datosNew,
                    tipoMoneda: tipoMoneda,
                  }).includes('-'),
                },
              ]"
            >
              {{
                `${simboloMoneda[tipoMoneda]} ${montoTotalSumary({
                  keyMap: `MontoRetIva`,
                  items: datosNew,
                  tipoMoneda: tipoMoneda,
                })}`
              }}
            </th>
            <th
              :class="[
                'subtitle-1',
                'text-right',
                'font-weight-bold',
                'text-no-wrap',
                {
                  'error--text': montoTotalSumary({
                    keyMap: `MontoPagar`,
                    items: datosNew,
                    tipoMoneda: tipoMoneda,
                  }).includes('-'),
                },
              ]"
            >
              {{
                `${simboloMoneda[tipoMoneda]} ${montoTotalSumary({
                  keyMap: `MontoPagar`,
                  items: datosNew,
                  tipoMoneda: tipoMoneda,
                })}`
              }}
            </th>
            <th
              :class="[
                'subtitle-1',
                'text-right',
                'font-weight-bold',
                'text-no-wrap',
                {
                  'error--text': montoTotalSumary({
                    keyMap: `SaldoPendiente`,
                    items: datosNew,
                    tipoMoneda: tipoMoneda,
                  }).includes('-'),
                },
              ]"
            >
              {{
                `${simboloMoneda[tipoMoneda]} ${montoTotalSumary({
                  keyMap: `SaldoPendiente`,
                  items: datosNew,
                  tipoMoneda: tipoMoneda,
                })}`
              }}
            </th>
            <th></th>
          </tr>
        </template>
      </v-data-table>
      <div class="d-flex justify-end pa-1">
        Total Saldo Pendiente: &nbsp;
        <span
          :class="[
            'font-weight-bold body-2',
            {
              'error--text': sumaPendiente < 0,
            },
          ]"
        >
          {{ simboloMoneda[tipoMoneda] }}
          {{ sumaPendiente | numeral("0,0.00") }}
        </span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import PdfCliente from "@/components/PdfDocCliente";
import { ExportDocsPendientes } from "@/components/ExcelExport";
import TrackCliente from "@/components/DocumentosCliente/Mobil/TrackCliente";
import Linkfact from "@/components/DatosFactura";

export default {
  components: {
    PdfCliente,
    TrackCliente,
    ExportDocsPendientes,
    Linkfact,
  },
  data() {
    return {
      isMobile: false,
      selectRif: 0,
      search: "",
      tab: 0,
      headersCliente: [
        {
          text: "Ver",
          align: "center",
          value: "NumeroDoc",
          groupable: false,
          sortable: false,
          divider: true,
          class: "subtitle-2",
        },
        {
          text: "Rif",
          align: "center",
          value: "Rif",
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2",
        },
        {
          text: "NumDoc",
          align: "center",
          value: "NumeroDoc",
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2",
          width: "120px",
        },
        {
          text: "Tipo Doc",
          align: "center",
          value: "TipoDoc",
          groupable: false,
          sortable: false,
          divider: true,
          class: "subtitle-2",
          width: "100px",
        },
        {
          text: "Fecha Emision",
          align: "center",
          value: "FechaEmision",
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2",
          width: "150px",
        },
        {
          text: "Entrega Cliente",
          align: "center",
          value: "FechaEntregaCli",
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2",
          width: "160px",
        },
        {
          text: "Fecha Vence",
          align: "center",
          value: "FechaVence",
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2",
          width: "160px",
        },
        {
          text: "Monto Original",
          align: "right",
          value: `MontoOriginal`,
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2",
        },
        {
          text: "Ret IVA por Cobrar",
          align: "right",
          value: `MontoRetIva`,
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2",
        },
        {
          text: "Monto por Cobrar",
          align: "right",
          value: `MontoPagar`,
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2",
        },
        {
          text: "Saldo",
          align: "right",
          value: "SaldoPendiente",
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2",
        },
        {
          text: "Mora",
          align: "center",
          value: "DiasMora",
          groupable: false,
          sortable: true,
          class: "subtitle-2",
          width: "120px",
        },
      ],
      chkGrpClie_Rif: true,
    };
  },
  props: {
    idcliente: Number,
  },

  computed: {
    ...mapState(["DetalleCliente", "simboloMoneda", "tipoMoneda", "dataUser", "Cliente"]),
    montoTotalSumary: function () {
      let numeral = require("numeral");

      return function ({ items = [], tipoMoneda, keyMap }) {
        let suma = 0;
        if (Object.entries(this.DetalleCliente).length !== 0) {
          if (items !== undefined) {
            suma = items.reduce(
              (acumulador, item) => acumulador + item[keyMap][tipoMoneda],
              0
            );
          }
          return numeral(suma).format("0,0.00");
        }
      };
    },
    rifList() {
      if (Object.entries(this.DetalleCliente).length !== 0) {
        const { dsDocument: { ttDetDocPed } = {} } = this.DetalleCliente;
        let datos = [];
        if (ttDetDocPed !== undefined) {
          datos = ttDetDocPed.map((item) => ({
            Rif: item.Rif,
            NombreRif: item.NombreRif,
          }));
          const rifData = [...new Set(datos)];

          const uniqueData = rifData.filter((item, index, self) => {
            return (
              index ===
              self.findIndex(
                (t) => t.Rif === item.Rif && t.NombreRif === item.NombreRif
              )
            );
          });
          return uniqueData;
        }
      }
    },
    sumaPendiente() {
      let cp = [];
      if (Object.entries(this.DetalleCliente).length !== 0) {
        const { dsDocument: { ttDetDocPed } = {} } = this.DetalleCliente;
        if (ttDetDocPed) {
          ttDetDocPed.forEach((item) => {
            cp.push(item["SaldoPendiente"][this.tipoMoneda]);
          });
          return cp.reduce(function (a, b) {
            return a + b;
          });
        }
      }
    },
    montoGroupSumary: function () {
      return function ({ isEmpreRif, items, tipoMoneda, keyMap, group }) {
        if (Object.entries(this.DetalleCliente).length !== 0) {
          const { dsDocument: { ttDetDocPed } = {} } = this.DetalleCliente;
          if (ttDetDocPed !== undefined) {
            const keyFilter = isEmpreRif ? `Empresa` : `NombreRif`;
            return Number(
              items
                .filter((x) => x[keyFilter] === group)
                .map((x) => x[keyMap][tipoMoneda])
                .reduce((a, b) => a + b, 0)
                .toFixed(2)
            );
          }
        }
      };
    },
    nbFile() {
      const { dsDocument: { ttCliente = [] } = {} } = this.DetalleCliente;
      const [cliente] = ttCliente;
      return cliente?.Codigo;
    },
    infoTt: function () {
      return function (idKey) {
        let datos = [];
        if (Object.entries(this.DetalleCliente).length !== 0) {
          const { dsDocument = {} } = this.DetalleCliente;
          let { [idKey]: xitem } = dsDocument;
          if (xitem !== undefined) {
            datos = xitem;
          }
        }
        if (idKey === "ttDetDocPed" && this.search !== "") {
          datos = datos.filter((item) => {
            const txt = `${item.NumeroDoc} ${item.Rif}`;
            return txt
              .toLowerCase()
              .includes(
                this.search !== "" ? this.search.toLowerCase() : item.Rif
              );
          });
        }
        if (idKey === "ttCliente" && this.search !== "") {
          datos.forEach((item) => (item.Rif = this.search.toUpperCase()));
        }
        return datos;
      };
    },
    datosNew() {
      let xdatos = [];
      if (Object.entries(this.DetalleCliente).length !== 0) {
        const { dsDocument: { ttDetDocPed } = {} } = this.DetalleCliente;
        if (ttDetDocPed !== undefined) {
          if (this.selectRif === 0) xdatos = ttDetDocPed;
          else
            xdatos = ttDetDocPed.filter((item) => item.Rif === this.selectRif);
        }
      }

      return xdatos;
    },
  },
  methods: {
    ...mapActions(["get_DetalleCliente"]),
    toggle() {
      this.$nextTick(() => {
        this.selectRif = 0;
      });
    },
    filteRif(value, search, item) {
      let txt = `${item.NumeroDoc} ${item.NombreRif} ${
        item.MontoOriginal[this.tipoMoneda]
      } ${item.SaldoPendiente[this.tipoMoneda]}`;
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        txt.toLowerCase().includes(search.toLowerCase())
      );
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
  },
};
</script>

<style>
#tbl_datos tr:nth-child(odd) {
  background: #ffffff;
  border-left: 2px solid #fe5000;
}
#tbl_datos tr:nth-child(even) {
  background: #eeeeee;
  border-left: 2px solid #002f6c;
}
</style>